import { useState, useMemo } from 'react'
import { useQuery } from 'react-query'
import axios from 'axios'

const useCarFormOptions = () => {
  const years = useMemo(() => {
    return Array(11)
      .fill(0)
      .map((_, i) => (new Date().getFullYear() - i).toString())
  }, [])

  const [selectedYear, setSelectedYear] = useState('')
  const [selectedMake, setSelectedMake] = useState('')
  const [selectedModel, setSelectedModel] = useState('')
  const [selectedVersion, setSelectedVersion] = useState('') // Guardaremos el ID de la versión aquí

  // 1. Fetch de Marcas
  const { data: makes = [], isLoading: isLoadingMakes } = useQuery(
    [selectedYear, 'makes'],
    async () => {
      const req = await axios.get(
        `${process.env.NEXT_PUBLIC_API_ROOT}/api/vehicle/makes?origin_source=cat_vehicle`,
        {
          params: {
            year: selectedYear,
          },
        },
      )
      // Limpiamos duplicados
      return [...new Set(req.data)]
    },
    {
      enabled: Boolean(selectedYear),
      refetchOnWindowFocus: false,
    },
  )

  // 2. Fetch de Modelos
  const { data: models = [], isLoading: isLoadingModels } = useQuery(
    [selectedYear, 'makes', selectedMake, 'models'],
    async () => {
      const req = await axios.get(
        `${process.env.NEXT_PUBLIC_API_ROOT}/api/vehicle/models?origin_source=cat_vehicle`,
        {
          params: {
            year: selectedYear,
            make: selectedMake,
          },
        },
      )
      return req.data
    },
    {
      enabled: Boolean(selectedYear && selectedMake),
      refetchOnWindowFocus: false,
    },
  )

  // 3. Fetch de Versiones (AJUSTADO AQUÍ)
  const { data: versions = [], isLoading: isLoadingVersions } = useQuery(
    [selectedYear, 'makes', selectedMake, 'models', selectedModel],
    async () => {
      const req = await axios.get(
        `${process.env.NEXT_PUBLIC_API_ROOT}/api/vehicle/versions?origin_source=cat_vehicle`,
        {
          params: {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel,
          },
        },
      )
      // Mapeamos la respuesta para regresar solo el ID y el nombre descriptivo
      return req.data.map((version) => ({
        id: version.id,
        name: version.name, // Puedes usar version.shortName si prefieres textos más cortos
      }))
    },
    {
      enabled: Boolean(selectedYear && selectedMake && selectedModel),
      refetchOnWindowFocus: false,
    },
  )

  // Manejadores de eventos
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value)
    setSelectedMake('')
    setSelectedModel('')
    setSelectedVersion('')
  }

  const handleMakeChange = (event) => {
    setSelectedMake(event.target.value)
    setSelectedModel('')
    setSelectedVersion('')
  }

  const handleModelChange = (event) => {
    setSelectedModel(event.target.value)
    setSelectedVersion('')
  }

  const handleVersionChange = (event) => {
    setSelectedVersion(event.target.value)
  }

  return {
    options: {
      years,
      makes,
      models,
      versions,
    },
    values: {
      selectedYear,
      selectedMake,
      selectedModel,
      selectedVersion,
    },
    handlers: {
      handleYearChange,
      handleMakeChange,
      handleModelChange,
      handleVersionChange,
    },
    status: {
      isLoadingMakes,
      isLoadingModels,
      isLoadingVersions,
    },
  }
}

export default useCarFormOptions
